import ReactDOM from 'react-dom/client';

import { AxiosResponse } from 'axios';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';

import './index.css';
import { StrictMode, Suspense } from 'react';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import App from './App';
import i18n from './i18n.ts';
import SnackbarProvider from './providers/SnackbarProvider.tsx';
import CaptchaControlProvider from './providers/CaptchaControlProvider.tsx';
import GlobalStoreProvider from './providers/GlobalStoreProvider.tsx';
import ChatClientProvider from './providers/ChatClientProvider.tsx';
import NotificationProvider from './providers/NotificationProvider.tsx';
import RevenueCatProvider from './providers/RevenueCatProvider.tsx';
import Backdrop from './ui/Backdrop.tsx';
import Spinner from './ui/Spinner.tsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      select: (res) => (res as AxiosResponse).data,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense
      fallback={
        <Backdrop>
          <Spinner />
        </Backdrop>
      }
    >
      <I18nextProvider i18n={i18n}>
        <SnackbarProvider>
          <CaptchaControlProvider>
            <QueryClientProvider client={queryClient}>
              <GlobalStoreProvider>
                <RevenueCatProvider>
                  <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_CAPTCHA_V3_KEY}>
                    <ChatClientProvider>
                      <NotificationProvider>
                        <App />
                      </NotificationProvider>
                    </ChatClientProvider>
                  </GoogleReCaptchaProvider>
                </RevenueCatProvider>
              </GlobalStoreProvider>
            </QueryClientProvider>
          </CaptchaControlProvider>
        </SnackbarProvider>
      </I18nextProvider>
    </Suspense>
  </StrictMode>,
);
